//client\src\components\EditPostModal.js
import React, { useState } from 'react';
import { authFetch } from '../../Utilities/Api';
import './EditPostModal.css';

const VISIBILITY_OPTIONS = [
    { value: 'public', label: '🌎 Public' },
    { value: 'friends-only', label: '🤝 Friends-Only' },
    { value: 'private', label: '🔒 Private' },
];

const EditPostModal = ({ post, onPostUpdated, onClose }) => {
    const [editText, setEditText] = useState(post.text || '');
    const [editVisibility, setEditVisibility] = useState(post.visibility || 'friends-only');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const trimmedText = editText.trim();

        if (!trimmedText && post.images.length === 0) {
            setError('Post must contain text or images.');
            setLoading(false);
            return;
        }

        try {
            const res = await authFetch(`/profile-posts/${post._id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    text: trimmedText,
                    visibility: editVisibility
                    // Note: You'd add image handling here if users can swap images.
                }),
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.message || 'Failed to update post.');
            }

            const updatedPost = await res.json();

            // Call the prop function to update the post state in PostItem.js
            onPostUpdated(updatedPost);
        } catch (err) {
            console.error('❌ Post update failed:', err);
            setError(err.message || 'An unexpected error occurred during update.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="edit-post-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Edit Post</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* 1. Text Area */}
                    <textarea
                        value={editText}
                        onChange={(e) => setEditText(e.target.value)}
                        placeholder="What's on your mind?"
                        rows="5"
                        disabled={loading}
                    />

                    {/* 2. Visibility Selector */}
                    <div className="form-group visibility-selector">
                        <label htmlFor="visibility">Post Visibility:</label>
                        <select
                            id="visibility"
                            value={editVisibility}
                            onChange={(e) => setEditVisibility(e.target.value)}
                            disabled={loading}
                        >
                            {VISIBILITY_OPTIONS.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* 3. Images Display (Read-Only or Edit Logic) */}
                    {post.images.length > 0 && (
                        <div className="image-preview-edit">
                            {/* In a real app, you'd add logic here to remove/swap images */}
                            <p>🖼️ **Images are currently read-only for this edit demo.**</p>
                        </div>
                    )}

                    {error && <p className="error-message">{error}</p>}

                    {/* 4. Submit Button */}
                    <button type="submit" disabled={loading || (editText === (post.text || '') && editVisibility === post.visibility)}>
                        {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EditPostModal;